const RideSeats = ({ classDetails, handleShow }) => {
  const seats = classDetails.seats;

  const getSeat = (num) => seats.find((s) => s.seat_number === num);

  const renderSeat = (num, style = {}) => {
    const s = getSeat(num);
    if (!s) return null;
    return (
      <div
        key={s.id}
        className={`bola-seat ${s.status === 1 ? 'ocupado' : ''}`}
        style={style}
        onClick={() => s.status !== 1 && handleShow(s.seat_number)}
      >
        <span>{s.seat_number}</span>
      </div>
    );
  };

  const coachImg  = classDetails.class.coach_image;
  const coachName = classDetails.class.coach_name;
  const isRide    = classDetails.class.type_class !== 'Train';

  return (
    <div className="ride-grid-wrapper">
    <div className="ride-grid">

      {/* Row 1 — col 1 */ renderSeat(1,  { gridColumn: 1, gridRow: 1 })}
      {/* Row 1 — col 2 */ renderSeat(2,  { gridColumn: 2, gridRow: 1 })}

      {/* Coach — cols 3-5 */}
      {/* <div
        className={`bola-coach ${!isRide ? 'bola-roja' : 'ride-coach'}`}
        style={{ gridColumn: '3 / span 3', gridRow: 1 }}
      >
        {coachImg ? (
          <img
            src={require(`../images/coaches/${coachImg}`)}
            alt={coachName}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
          />
        ) : (
          <span className="name-coach">{coachName || 'Coach'}</span>
        )}
      </div> */}


        {coachImg ? (
          <div
            className={`bola-coach ${!isRide ? 'bola-roja' : 'ride-coach'}`}
            style={{ gridColumn: '3 / span 3', gridRow: 1, backgroundImage: `url(${require(`../images/coaches/${coachImg}`)})` }}
          >
          </div>
        ) : (
          <div
            className={`bola-coach ${!isRide ? 'bola-roja' : 'ride-coach'}`}
            style={{ gridColumn: '3 / span 3', gridRow: 1 }}
          >
            <span className="name-coach">{coachName || 'Coach'}</span>
          </div>
        )}

      {/* Row 1 — col 6 */ renderSeat(3,  { gridColumn: 6, gridRow: 1 })}
      {/* Row 1 — col 7 */ renderSeat(4,  { gridColumn: 7, gridRow: 1 })}

      {/* Row 2 — cols 1-7 */}
      {[5, 6, 7, 8, 9, 10, 11].map((num, i) => renderSeat(num, { gridColumn: i + 1, gridRow: 2 }))}

      {/* Row 3 — col 1 spacer (nothing behind seat 5) */}
      <div style={{ gridColumn: 1, gridRow: 3 }} />

      {/* Row 3 — cols 2-7 */}
      {[12, 13, 14, 15, 16, 17].map((num, i) => renderSeat(num, { gridColumn: i + 2, gridRow: 3 }))}

    </div>
    </div>
  );
};

export default RideSeats;